module.exports = __webpack_public_path__ + "img/19.058b08c7.svg";